export default __webpack_public_path__ + "static/media/landing-mobile-placeholder.685ca8c2.jpg";